import Swiper, { Autoplay, Pagination } from "swiper";

function initTrustpilotCarousel(banner) {
  const trustpilotCarousel = banner.querySelector(
    ".js-bannerTrustpilotCarousel"
  );

  const logoCarousel = banner.querySelector(".js-bannerPromoCarousel");

  if (logoCarousel) {
    const pagination = banner.querySelector(
      ".js-bannerPromoCarouselPagination"
    );

    const carousel = new Swiper(logoCarousel, {
      modules: [Autoplay, Pagination],
      slidesPerView: 2,
      spaceBetween: 40,
      speed: 750,
      autoplay: {
        delay: 3000,
      },
      loop: true,

      pagination: {
        el: pagination,
      },
      breakpoints: {
        1024: {
          loop: false,
          autoplay: false,
          pagination: false,
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 30,
        },
      },
    });
  }

  if (trustpilotCarousel) {
    setTimeout(function () {
      const carousel = new Swiper(trustpilotCarousel, {
        modules: [Autoplay],
        slidesPerView: 1.25,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        speed: 1000,
        autoplay: true,
        breakpoints: {
          640: {
            // centeredSlides: false,
            slidesPerView: 2.5,
            spaceBetween: 32,
          },
          1024: {
            // centeredSlides: false,
            slidesPerView: "auto",
            // slidesPerView: 3.5,
            spaceBetween: 50,
          },
          1280: {
            slidesPerView: "auto",
            spaceBetween: 50,
          },
        },
      });
    }, 2000);
  }
}

function initForm(banner) {
  const bannerForms = document.querySelectorAll(".js-bannerForm");

  bannerForms.forEach(function (form) {
    const stepTrackText = form.querySelector(".js-bannerFormStepTrackText");

    if (stepTrackText) {
      const stepIndicator = form.querySelector(
        `.js-bannerFormStepIndicator[data-step='${stepTrackText.dataset.step}']`
      );

      if (stepIndicator) {
        stepIndicator.classList.add("active");
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const banners = document.querySelectorAll(".js-banner");

  banners.forEach(function (banner) {
    initTrustpilotCarousel(banner);
    initForm(banner);
  });
});
